// Class: starling.utils.ScaleMode

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;

// Constructor

var ScaleMode = function(){}

// Meta

ScaleMode.__name__ = ["starling","utils","ScaleMode"];
ScaleMode.prototype = {
	
};
ScaleMode.prototype.__class__ = ScaleMode.prototype.constructor = $hxClasses["starling.utils.ScaleMode"] = ScaleMode;

// Init



// Statics

ScaleMode.isValid = function(scaleMode) {
	if(!(scaleMode == "none" || scaleMode == "noBorder")) {
		return scaleMode == "showAll";
	} else {
		return true;
	}
}
ScaleMode.NONE = "none"
ScaleMode.NO_BORDER = "noBorder"
ScaleMode.SHOW_ALL = "showAll"

// Export

exports.default = ScaleMode;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/utils/ScaleMode.js
// module id = 101
// module chunks = 0